import { render } from "./MobileBottomBanner.vue?vue&type=template&id=38ea078f&scoped=true"
import script from "./MobileBottomBanner.vue?vue&type=script&lang=js"
export * from "./MobileBottomBanner.vue?vue&type=script&lang=js"

import "./MobileBottomBanner.vue?vue&type=style&index=0&id=38ea078f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ea078f"]])

export default __exports__